const { h } = require('preact');

function Loading() {
  return <div className="loading loading-lg">Loading...</div>;
}

module.exports = Loading;
